import store from '../store'

export function checkIsOutOfHours() {
    const subProfile = store.getters.getActiveSubProfile;
    if(subProfile && subProfile._id) {
        const now = new Date().getTime();
        let fromHours = subProfile.play_from || subProfile.game_restriction.play_from;
        let toHours = subProfile.play_to || subProfile.game_restriction.play_to;
        let from = new Date();
        let to = new Date();

        if(fromHours.length > 2) {
            from.setHours(fromHours.split(":")[0], fromHours.split(":")[1]);
        } else {
            from.setHours(fromHours);
        }

        if(toHours.length > 2) {
            to.setHours(toHours.split(":")[0], toHours.split(":")[1], 0);
        } else {
            to.setHours(toHours);
        }

        from = from.getTime();
        to = to.getTime();
            
        if(now < from || now > to) {
            store.dispatch("setIsOutOfHours", true);  
            return true;
        }
                
        store.dispatch("setIsOutOfHours", false);    
        return false;
    }
        
    store.dispatch("setIsOutOfHours", false);  
} 